import { getDependentColor } from './DependentBadge';

interface DependentChipsProps {
  dependents: Array<{ id: string; name: string }>;
  activeIds: Set<string>;
  onToggle: (id: string) => void;
}

export function DependentChips({ dependents, activeIds, onToggle }: DependentChipsProps) {
  if (dependents.length <= 1) return null;

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {dependents.map((dep, index) => {
        const active = activeIds.has(dep.id);
        const color = getDependentColor(index);
        return (
          <button
            key={dep.id}
            onClick={() => onToggle(dep.id)}
            className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium border transition-colors ${
              active
                ? `${color.bg} ${color.text} ${color.border}`
                : 'bg-gray-100 text-gray-400 border-gray-200 line-through'
            }`}
          >
            <span className={`w-2.5 h-2.5 rounded-full shrink-0 ${active ? color.dot : 'bg-gray-300'}`} />
            {dep.name}
          </button>
        );
      })}
    </div>
  );
}
